import React from 'react'

const Error = () => {
    return (
        <h6 style={ErrorStyle} >
            *Data member already exists
        </h6>
    )
}
const ErrorStyle = {
    color: "red"
}

export default Error
